const binding = { modules: {}, dataActions: {} };

    (binding.modules['eve-secure-container'] = {
        c: () => require('partner/modules/eve-secure-container/eve-secure-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'eve-secure-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/eve-secure-container'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|eve-secure-container|eve-secure-container'] = {
                c: () => require('partner/modules/eve-secure-container/eve-secure-container.view.tsx'),
                cn: '__local__-__local__-eve-secure-container'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };